var _excluded = ["children", "title", "description", "position", "width", "height"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { node, number, oneOf, string } from 'prop-types';
import { Text } from '@gympass/yoga';
import { PopoverContainer, Wrapper } from './styles';

function Popover(_ref) {
  var children = _ref.children,
      title = _ref.title,
      description = _ref.description,
      position = _ref.position,
      width = _ref.width,
      height = _ref.height,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useState = useState(false),
      isPopoverOpen = _useState[0],
      setIsPopoverOpen = _useState[1];

  function handleShowPopover() {
    setIsPopoverOpen(true);
  }

  function handleHidePopover() {
    setIsPopoverOpen(false);
  }

  return /*#__PURE__*/React.createElement(Wrapper, props, isPopoverOpen && /*#__PURE__*/React.createElement(PopoverContainer, {
    position: position,
    width: width,
    height: height,
    role: "tooltip"
  }, !!title && /*#__PURE__*/React.createElement(Text.Small, {
    mb: "xxxsmall",
    fw: "medium",
    color: "white"
  }, title), /*#__PURE__*/React.createElement(Text.Small, {
    m: "zero",
    color: "white"
  }, description)), /*#__PURE__*/React.createElement("div", {
    onMouseEnter: handleShowPopover,
    onMouseLeave: handleHidePopover
  }, children));
}

Popover.propTypes = {
  children: node.isRequired,
  title: string,
  description: string.isRequired,

  /** Position of the popover relative to the children. Accepted values: bottom-[start|center|end], left-[start|center|end], top-[start|center|end] or right-[start|center|end] */
  position: oneOf(['bottom-start', 'bottom-center', 'bottom-end', 'left-start', 'left-center', 'left-end', 'top-start', 'top-center', 'top-end', 'right-start', 'right-center', 'right-end']),
  width: number,
  height: number
};
Popover.defaultProps = {
  title: undefined,
  position: 'bottom-center',
  width: 265,
  height: 116
};
export default Popover;